/* eslint-disable max-len */
/* eslint-disable react/no-unescaped-entities */
import React from 'react'
import _ from 'lodash';

export default function EmptyFilterPage({ text, subtext }) {
    return (
        <div className={`flex justify-center items-center overflow-auto sidebar pt-5`}>
            <div className="flex flex-col text-center ">
                <img src="/assets/images/empty.png" className={'pb-2  w-[240px]'} alt="" />
                {/* ps-[68px] [calc(100vh-460px)]*/}
                <p className=" text-base font-normal text-black">
                    {text} <br/>
                    {subtext}
                </p>
            </div>
        </div>
    )
}
